<template>
  <div>

  <el-row>
    <br />
  </el-row>
  <el-row :gutter="20">
    <el-col :span="6">
      <el-upload
        class="upload-demo"
        drag
        action="/api/upload_excel/"
        accept=".xls,.xlsx"
        :on-change="importf"
        :show-file-list="false"
        :auto-upload="false"
       >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <template #tip>
          <div class="el-upload__tip">
            只能上传 xlsx/xls 文件，且不超过 5MB
          </div>
        </template>
      </el-upload>
    </el-col>
    <el-col :span="18">
      <el-table :data="list" border style="width: 100%; text-align: center;" fit  stripe v-if="table_flag" size="mini">
               <el-table-column prop="meta_uuid" label="META UUID"  width="270" align="center"></el-table-column>
               <el-table-column prop="episode_url" label="Episode_url" min-width="9%" align="center"></el-table-column>
               <el-table-column prop="series_url" label="Series_url" min-width="9%" align="center"></el-table-column>
               <!-- <el-table-column prop="status" label="Status" width="100" align="center">
                 <template v-slot="st" >
                   <div :class="(st.row.status == 'success')?'ok_status':'error_status' " v-loading="st.row.status=='loading'">{{st.row.status}}</div>
                 </template>
               </el-table-column> -->
      </el-table>
    </el-col>

  </el-row>


  <el-dialog :visible.sync="upload_flag" :modal=false :show-close=false width="30%" center>

    <span>请确认上传<br /><br /></span>
    <span v-if="list.length == 0">You have not selected any One !</span><br />
    <span v-if="list.length != 0">check yes</span><br />

    <span slot='footer' class="dialog-footer">
      <el-button @click="upload_flag=false" v-if="list.length != 0">取消</el-button>
      <el-button type="primary" @click="upload_excel()" v-if="list.length != 0">确定</el-button>
      <el-button type="primary" @click="upload_flag=false" v-if="list.length == 0">OK</el-button>
    </span>
  </el-dialog>




  </div>
</template>

<script>
  import XLSX from 'xlsx'
  export default {
    name: 'Upload_excel',
    data() {
      return {
        title: 'upload_excel page',
        list: [],
        table_flag:false,
        upload_flag:false,
        rABS:false,
        wb:''
      }
    },
    methods: {
      upload_excel:function(){
        let that = this
        that.upload_flag = false
        this.$axios({
            method: 'POST',
            url: '/api/upload_excel/',
            data: that.list
          })
          .then(response => {
            if (0 == response.data.code) {
              this.$message.success('上传成功')
            }else{
              this.$message.error('上传失败。')
            }
          })

          // that.loading_flag = false


      },
      ref_status: function(row, column) {
         let pr = column.property
         if (row[pr]) {
           return row[pr]
         } else {
           return 'loadding'
         }
       },
      rowClass2: function({
        row,
        rowIndex
      }) {
        return ''
      },

      importf: function(file){
       this.file = file;
              const isLt5M = file.size/1024/1024 < 5;
              const extention = file.name.split('.')[1] === 'xls';
              const extention2 = file.name.split('.')[1] === 'xlsx';
            // console.log(extention,extention2,isLt5M)
              if(!extention&&!extention2){
                this.$message.warning('长传的文件只能是Excel')
                return false
              }
              if(!isLt5M){
                this.$message.warning('文件大小不能超过5MB')
                return false
              }
              let data1 = XLSX.utils.sheet_to_json(file.name)
            var f = file.raw;
            var that = this;
            var reader = new FileReader();
            reader.onload = function(e) {
              // console.log(e)
              let wb = that.wb
              var data = e.target.result;
              if(that.rABS) {
                wb = XLSX.read(btoa(that.fixdata(data)), {//手动转化
                  type: 'base64'
                });
              } else {
                wb = XLSX.read(data, {
                  type: 'binary'
                });
              }
              // wb.SheetNames[0]是获取Sheets中第一个Sheet的名字
              // wb.Sheets[Sheet名]获取第一个Sheet的数据
              // document.getElementById("demo").innerHTML= JSON.stringify( XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]) );
              // let data1 =  JSON.stringify( XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]) );
              let data1 = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
              // for (let i = 0; i < data1.length; i++) {
              //   data1[i].status = 'loading'
              // }
              that.list = data1
              that.table_flag = true
              that.upload_flag = true
            };
            if(this.rABS) {
              reader.readAsArrayBuffer(f);
            } else {
              reader.readAsBinaryString(f);
            }

          },


    },
  }
</script>

<style>
  .ok_status{
    font-weight: bold;
    color: #409eff;
    border: 0;
    outline: #0f80ff;
    border-radius: 0.4rem;
    /*box-shadow: 0.125rem 0rem 0rem #000000;*/
    background-color: white;
  }
  .error_status{
    font-weight: bold;
    color: #fc0107;
    border: 0;
    outline: #fc0107;
    border-radius: 0.4rem;
    /*box-shadow: 0.125rem 0rem 0rem #000000;*/
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/upload_excel.vue